import gqlTagGira from 'graphql-tag';

export const DATE_FRAGMENT = gqlTagGira`
    fragment jiraDateFieldFragment on JiraDatePickerField {
        date
    } 
`;
